var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1150 -480)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1165.082 480)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.992,804.353a.492.492,0,0,1-.348-.84l3.587-3.587-3.587-3.587a.492.492,0,0,1,.7-.7l3.934,3.934a.493.493,0,0,1,0,.7l-3.934,3.934A.49.49,0,0,1,525.992,804.353Z",
    transform: "translate(-525.5 -795.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1150 483.935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.369,822.582H480.32a.82.82,0,0,1-.82-.82V808.32a.82.82,0,0,1,.82-.82h4.918a.492.492,0,1,1,0,.984h-4.754V821.6H497.2v-7.7a.492.492,0,1,1,.984,0v7.869A.82.82,0,0,1,497.369,822.582Z",
    transform: "translate(-479.5 -807.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1154.918 483.935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.992,816.09a.492.492,0,0,1-.492-.492,8.075,8.075,0,0,1,8.033-8.1h6.23a.492.492,0,1,1,0,.984h-6.23a7.09,7.09,0,0,0-7.049,7.115A.492.492,0,0,1,494.992,816.09Z",
    transform: "translate(-494.5 -807.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.c9166083bc93ce3b3ad71c5979513eae.svg";
export { ForwardRef as ReactComponent };